import React from "react";
import PropTypes from "prop-types";

import {
	AMERICAN_EXPRESS,
	VISA,
	MASTER_CARD,
	DISCOVER,
} from "shared/payment/constants";
import getImagePath from "shared/util/getImagePath";

import "./CardIcon.scss";

const IMAGE_PATH = `${getImagePath()}media/img/credit_cards`;

const CARD_TYPE_TO_IMAGE = {
	[AMERICAN_EXPRESS]: `${IMAGE_PATH}/amex.png`,
	[VISA]: `${IMAGE_PATH}/visa.png`,
	[MASTER_CARD]: `${IMAGE_PATH}/mastercard.png`,
	[DISCOVER]: `${IMAGE_PATH}/discover.png`,
};


const CardIcon = ({ cardType, className }) => {
	return (
		<div className={className}>
			<img
				src={CARD_TYPE_TO_IMAGE[cardType]}
				alt="credit-card"
				className="card-icon"
			/>
		</div>
	);
};

CardIcon.propTypes = {
	cardType: PropTypes.oneOf(Object.keys(CARD_TYPE_TO_IMAGE)).isRequired,
	className: PropTypes.string,
};

CardIcon.defaultProps = {
	className: "",
};

export default CardIcon;



// WEBPACK FOOTER //
// ./src/apps/payment/components/CreditCardForm/CardIcon/CardIcon.jsx